import { Injectable, InjectionToken } from "@angular/core";
import { CustomTextGetQuery, CustomTextGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class ICustomTextApiService {
  abstract swagCustomTextGet(query: CustomTextGetQuery): Promise<CustomTextGetQueryResult>
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ICustomTextApiServiceToken = new InjectionToken<ICustomTextApiService>('ICustomTextApiServiceToken');
